// Source: app/scripts/controllers/page.js
/**
 * Created by ristes on 20.4.15.
 */



Auction.controller('PageController', ['$scope', '$modal', '$filter', 'Page',
  function ($scope, $modal, $filter, Page) {

    $scope.modalAssign = $modal({
      scope: $scope,
      title: $filter('translate')('eauction.assign_appraisal'),
      template: 'templates/modal-form.tpl.html',
      contentTemplate: 'forms/admin/auth/assign_page.html',
      show: false
    });


    $scope.loadAssignments = function (page) {
      $scope.userRolePages = Page.findAssigned({
        id: page.id
      });
    };

    $scope.assign = function (page) {
      $scope.page = page;
      $scope.assignmentEntity = {};
      $scope.loadAssignments(page);
      $scope.modalAssign.$promise.then($scope.modalAssign.show);
    };

    $scope.save = function () {
      var roles = $scope.assignmentEntity.roles;
      Page.assign({
        page: $scope.page,
        roles: roles
      }, function () {
        $scope.userRolePages.length = 0;
        $scope.loadAssignments($scope.page);
      });
    };

    $scope.onGroupsInit = function (_scope) {
      _scope.assign = $scope.assign;

      _scope.faChange = function (n, o) {
        if (!n) return;
        _scope.entity.icon = 'fa fa-fw ' + n;
      };

      _scope.renderIcon = function (clean, formated) {
        return "<i class='fa fa-fw " + clean + "'></i> " + formated;
      };
    };
  }
]);
